<template>
  <router-link
    class="item f-left"
    :to="{name:'BookDetail',params:{id:item.id},query:{title:$route.query.title,recommend:$route.query.recommend}}"
  >
    <div class="cover-wrap">
      <img class="cover" :src="item.cover_img" />
    </div>
    <div class="right">
      <div class="title-wrap">
        <img class="tag" src="@/assets/images/common/coupon@2x.png" v-if="item.is_has_coupon==1" />
        <img
          class="tag"
          src="@/assets/images/common/spell@2x.png"
          v-if="item.spell_id>0||item.is_join_spell==1"
        />
        <span class="title">{{item.name||item.title}}</span>
      </div>
      <div class="author">作者：{{item.author}}</div>
      <div class="introduce">{{item.instruction}}</div>
      <div class="bottom">
        <CurrencyNew
          :price="item.price"
          :priceUnderline="item.underlined_price"
          :priceTwo="true"
          :isUnderlineLeft="false"
        ></CurrencyNew>
      </div>
    </div>
  </router-link>
</template>
<script>
export default {
  name: "BookItem",
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.item {
  width: 371px;
  height: 196px;
  box-sizing: border-box;
  margin-bottom: 36px;
  margin-right: 43px;
  position: relative;
  border-radius: 6px;
  border: 1px solid rgba(237, 237, 237, 1);
  background-color: white;
  display: flex;
  &:hover {
    box-shadow: 0px 3px 15px 0px rgba(224, 224, 224, 1);
    .cover {
      transform: scale(1.1);
    }
  }
  &:nth-child(3n) {
    margin-right: 0;
  }
  .cover-wrap {
    width: 139px;
    margin-right: 18px;
    overflow: hidden;
    flex-shrink: 0;
    border-radius: 6px;
  }
  .cover {
    border-radius: 6px;
    width: 100%;
    height: 100%;
    transform: scale(1);
    transition: 0.5s all;
  }
  .right {
    flex-grow: 1;
    padding-right: 32px;
    overflow: hidden;
  }
  .title-wrap {
    display: flex;
    align-items: center;
    overflow: hidden;
    margin-top: 22px;
  }
  .title {
    flex-grow: 1;
    font-size: 18px;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    line-height: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    &:hover {
      color: $primary-color;
    }
  }
  .author {
    font-size: 16px;
    color: #666666;
    line-height: 1;
    margin-top: 17px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .introduce {
    height: 48px;
    font-size: 16px;
    color: #999999;
    line-height: 24px;
    margin: 13px 0 20px 0;
    text-align: justify;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
  .tag {
    width: 22px;
    height: 20px;
    margin-right: 8px;
    vertical-align: 2px;
    float: left;
  }
  .bottom {
    /deep/ {
      .price-wrap {
        justify-content: flex-start;
      }
      .price {
        margin-right: 8px;
      }
    }
  }
}
</style>